import styled from '@emotion/styled'
import useDrawer from 'modules/drawer/state/use-drawer'
import { drawerKeyToComponentMap } from './drawer.utils'

type DrawerPosition = 'left' | 'right' | 'center'
type DrawerDirection = 'leftToRight' | 'topToBottom' | 'bottomToTop'

interface DrawerProps {
  position: DrawerPosition
  direction: DrawerDirection
}

const Drawer = ({ position, direction }: DrawerProps) => {
  const drawer = useDrawer()

  const CurrentDrawerPanel = drawer.current ? drawerKeyToComponentMap[drawer.current.key] : null

  return (
    <Outer isOpen={!!drawer.current} position={position} direction={direction}>
      {CurrentDrawerPanel ? <CurrentDrawerPanel /> : null}
    </Outer>
  )
}

const Outer = styled.div<{ isOpen: boolean; position: DrawerPosition; direction: DrawerDirection }>`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: white;
  position: absolute;
  transition: transform 0.25s;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};

  ${({ isOpen, direction }) => {
    let transform = ''

    if (isOpen) {
      if (direction === 'topToBottom' || direction === 'bottomToTop') {
        transform = 'translateY(0)'
      } else if (direction === 'leftToRight') {
        transform = 'translateX(0)'
      }
    } else {
      if (direction === 'topToBottom') {
        transform = 'translateY(-100%)'
      } else if (direction === 'bottomToTop') {
        transform = 'translateY(100%)'
      } else if (direction === 'leftToRight') {
        transform = 'translateX(-100%)'
      }
    }

    return { transform }
  }}

  ${({ position }) => (position === 'right' ? { display: 'none' } : { display: 'block' })};

  @media (min-width: 784px) {
    ${({ position }) => (position === 'left' ? { display: 'none' } : { display: 'block' })}
  }
`

export default Drawer
